module.exports = __webpack_public_path__ + "img/arena-closed.dfe17368.png";